'use client';

import { useCallback, useState, useTransition } from 'react';

import type { WorkPageTab } from '@/features/fanfic-page/utils';

export interface UseFanficPageTabsReturn {
  activeTab: WorkPageTab;
  setActiveTab: (tab: WorkPageTab) => void;
}

export interface UseFanficPageTabsProps {
  initialTab?: WorkPageTab;
}

/**
 * Hook for work-page tabs. Initial tab can come from SSR deep-link query.
 */
export const useFanficPageTabs = ({
  initialTab = 'description',
}: UseFanficPageTabsProps = {}): UseFanficPageTabsReturn => {
  const [activeTab, setActiveTabState] = useState<WorkPageTab>(initialTab);
  const [, startTransition] = useTransition();

  const setActiveTab = useCallback((tab: WorkPageTab) => {
    startTransition(() => {
      setActiveTabState(tab);
    });
  }, []);

  return {
    activeTab,
    setActiveTab,
  };
};
